import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { TrainingProgramsComponent } from './training-programs/training-programs.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { NewStudentRegistrationComponent } from './new-student-registration/new-student-registration.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SelectLocationComponent } from './select-location/select-location.component';
import { PaymentComponent } from './payment/payment.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { ClassHistoryLookupComponent } from './class-history-lookup/class-history-lookup.component';
import { PastStudentInfoComponent } from './past-student-info/past-student-info.component';
import { StaffRegistrationComponent } from './staff-registration/staff-registration.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';
import { PaymentOnlineClassComponent } from './payment-online-class/payment-online-class.component';
import { PaymentConfirmationOnlineClassComponent } from './payment-confirmation-online-class/payment-confirmation-online-class.component';
import { MhsLoginComponent } from './login/mhs-login/mhs-login.component';
import { CreateLoginComponent } from './login/create-login/create-login.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'training-programs', component: TrainingProgramsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'new-student-registration', component: NewStudentRegistrationComponent },
  { path: 'select-location', component: SelectLocationComponent },
  { path: 'payment', component: PaymentComponent },
  { path: 'payment-confirmation', component: PaymentConfirmationComponent },
  { path: 'class-history-lookup', component: ClassHistoryLookupComponent },
  { path: 'past-student-info', component: PastStudentInfoComponent },
  { path: 'staff-registration', component: StaffRegistrationComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'confirm-password', component: ConfirmPasswordComponent },
  { path: 'payment-online-class', component: PaymentOnlineClassComponent },
  { path: 'payment-confirmation-online-class', component: PaymentConfirmationOnlineClassComponent },
  { path: 'mhs-login', component: MhsLoginComponent, data: { title: 'Login Page' } },
  { path: 'create-login', component: CreateLoginComponent },
  { path: 'refund-policy', component: RefundPolicyComponent },
  { path: '**', component: PageNotFoundComponent } /*needs to be the last route in this in order to work*/
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts